import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "contacts",
  class: "max-w-1440px mx-auto pt-183px <lg:pt-60px"
}
const _hoisted_2 = { class: "w-full h-230px px-135px <xl:px-85px <lg:px-40px flex mb-75px <750:mb-30px -mt-75px <sm:mt-40px <750:px-50px <750:block <750:h-auto" }
const _hoisted_3 = { class: "w-270px h-full flex-none" }
const _hoisted_4 = { class: "w-full h-full pl-30px <750:pl-0 <750:mt-20px" }
const _hoisted_5 = { class: "flex px-30px <1300:px-15px pt-30px w-full h-70px relative <750:px-0 <750:pt-20px <750:block" }
const _hoisted_6 = {
  key: 0,
  class: "absolute flex items-center top-1/2 left-1/2 transform -translate-x-1/2"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-24px ml-20px <sm:ml-10px <sm:text-14px" }
const _hoisted_9 = {
  key: 0,
  class: "w-full text-17px <1300:text-15px <lg:text-12px leading-20px text-hex-7E7E7E text-right <750:text-left <750:text-12px"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_block = _resolveComponent("top-block")!
  const _component_text_input = _resolveComponent("text-input")!
  const _component_accent_button = _resolveComponent("accent-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_block, {
      class: "<sm:hidden",
      hide_logo: "",
      hide_enter_button: "",
      title: "Контакты"
    }, {
      default: _withCtx(() => _cache[9] || (_cache[9] = [
        _createTextVNode("Всегда на связи")
      ])),
      _: 1
    }),
    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "sm:hidden uppercase px-50px text-18px text-black mb-5px mt-35px font-500" }, " Контакты ", -1)),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "sm:hidden uppercase px-50px text-14px text-black" }, " Всегда на связи ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_text_input, {
          placeholder: "Имя",
          type: "text",
          error: _ctx.name === '' && _ctx.submitted,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitted = false)),
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
          ],
          modelValue: _ctx.name
        }, null, 8, ["error", "modelValue"]),
        _createVNode(_component_text_input, {
          class: "mt-35px <750:mt-20px",
          placeholder: "Email",
          type: "email",
          error: _ctx.email === '' && _ctx.submitted,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => (_ctx.submitted = false)),
            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event))
          ],
          modelValue: _ctx.email
        }, null, 8, ["error", "modelValue"]),
        _createVNode(_component_text_input, {
          type: "tel",
          class: "mt-35px <750:mt-20px",
          placeholder: "Телефон",
          error: _ctx.phone === '' && _ctx.submitted,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitted = false)),
            _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phone) = $event))
          ],
          modelValue: _ctx.phone
        }, null, 8, ["error", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_text_input, {
          class: "h-162px <lg:h-142px",
          placeholder: "Сообщение...",
          type: "textarea",
          error: _ctx.text === '' && _ctx.submitted,
          "onUpdate:modelValue": [
            _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitted = false)),
            _cache[7] || (_cache[7] = ($event: any) => ((_ctx.text) = $event))
          ],
          modelValue: _ctx.text
        }, null, 8, ["error", "modelValue"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.clicked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("img", {
                      src: 
                  !_ctx.error
                    ? require('../assets/icons/success_icon.svg')
                    : require('../assets/icons/icon_error.svg')
                ,
                      class: "w-50px h-50px <sm:w-25px <sm:h-25px"
                    }, null, 8, _hoisted_7),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(!_ctx.error ? "Сообщение успешно отправлено" : _ctx.errorMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (!_ctx.clicked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[10] || (_cache[10] = [
                    _createTextVNode(" Нажимая на кнопку, вы даете согласие на "),
                    _createElementVNode("a", {
                      class: "underline hover:text-hex-6664D6",
                      href: "https://e-rko.ru/privacy_policy.pdf"
                    }, "обработку персональных данных", -1),
                    _createTextVNode(" и соглашаетесь с "),
                    _createElementVNode("a", {
                      class: "underline hover:text-hex-6664D6",
                      href: "https://e-rko.ru/terms_of_use.pdf"
                    }, "пользовательским соглашением", -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (!_ctx.clicked)
                ? (_openBlock(), _createBlock(_component_accent_button, {
                    key: 0,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clickHandler())),
                    class: "ml-45px <1300:ml-25px <lg:text-16px flex-none mt-2px h-25px <750:ml-0 <750:mt-15px"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("Отправить "),
                      _createElementVNode("span", { class: "<1150:hidden" }, "сообщение", -1)
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}